<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
        <el-button-group>
          <el-button type="primary" @click="add" size="small">添加账号</el-button>
        </el-button-group>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="150">
            <template slot-scope="scope">
              <!--修改-->
              <el-button type="text" @click="revise(scope.row)">修改</el-button>
              <!--禁用-->
              <el-button class="color-danger" type="text" @click="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
    <manager-operate v-if="managerOperate.visible" :dialog-data="managerOperate" @table-reload="getTableList"/>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import {adminAccountStatus} from "@utils/formatList"
  import ManagerOperate from "./dialog/ManagerOperate"
  export default {
    name: "managerList",
    mixins: [PagingData],
    components: {ManagerOperate},
    data() {
      return {
        // 统计
        countList: [
          {name: "总记录", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "账号", property: "username"},
            {label: "姓名", property: "name"},
            {label: "手机号", property: "mobile"},
            {label: "所属角色", property: "role.name"},
            {label: "状态", property: "status", format: adminAccountStatus},
          ]
        },
        managerOperate: {visible: false, title: "", row: null, width: 450},
      }
    },
    methods: {
      add() {
        this.managerOperate.title = "添加子账号";
        this.managerOperate.visible = true;
        this.managerOperate.row = null;
      },
      revise(row) {
        this.managerOperate.title = "修改子账号";
        this.managerOperate.visible = true;
        let nv = {...row};
        nv.role_id = row?.role?.id;
        this.managerOperate.row = nv;
      },
      remove(row) {
        this.openConfirm("删除该子账号", async ()=> {
          let nv = {};
          nv.optionId = row.id;
          let res = await this.$Http.deleteManager(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.$refs["paging"].removeFinish(1);
            this.getTableList();
          }
        });
      },
      async getTableList() {
        let params = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize
        };
        let res = await this.$Http.getManagerList(params);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      }
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
